export enum VenueTypeEnum {
  Cinema = 1,
  IMAX = 2,
  VIP = 3,
  Business = 4,
  FourDX = 5,
  DBox = 6,
  ScreenX = 7
}
